import gql from 'graphql-tag';

export default gql`
  mutation UpdateShop(
    $data: ShopUpdateInput!
    $id: ID!
  ) {
    updateShop(
      id: $id
      data: $data
    ) {
      id
      name
      status
      menus
      pdfs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateShop.ts